export default __webpack_public_path__ + "static/media/Linked Learning C sharp.21244d15.webp";